module.exports = "/static/login/banner.jpg";